const pink = {
  25: "#FEF6FB",
  50: "#FDF2FA",
  100: "#FCE7F6",
  200: "#FCCEEE",
  300: "#FAA7E0",
  400: "#F670C7",
  500: "#EE46BC",
  600: "#DD2590",
  700: "#C11574",
  800: "#9E165F",
  900: "#851651",
  950: "#4E0D30",
};

export default pink;
